import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {Tag} from "primereact/tag";
import {AppContext} from "../HomePage";
import {AnnouncementService} from "../service/AnnouncementService";
import AnnouncementBody, {pickLocalized} from "./AnnouncementBody";
import {Loading} from "../utils/InlineComponents";
import {toDateTimeString} from "../utils/TimeUtil";
import {isAdmin, isManager} from "../utils/Utils";

// Persistent What's New page: lists every published announcement, tags the
// not-yet-seen ones, and acknowledges them once rendered (except for
// admin/manager sessions — see the impersonation note in App.js).
const Announcements = () => {

    const {t, setError} = React.useContext(AppContext);
    const {i18n} = useTranslation();
    const announcementService = new AnnouncementService();

    const [announcements, setAnnouncements] = useState(null);

    useEffect(() => {
        announcementService.list().then(items => {
            setAnnouncements(items);
            const unseenIds = (items || []).filter(a => !a.seen).map(a => a.id);
            if (unseenIds.length > 0 && !isAdmin() && !isManager())
                announcementService.markSeen(unseenIds).catch(() => {});
        }).catch(error => { setError(error); setError(null); setAnnouncements([]); });
    }, []);

    return <div className="card">
        <h2>{t('announcement.whats_new')}</h2>
        {announcements === null
            ? <div style={{textAlign: 'center'}}><Loading/></div>
            : (announcements.length === 0
                ? <div style={{color: 'var(--text-color-secondary)'}}>{t('announcement.empty')}</div>
                : announcements.map(a => (
                    <div key={a.id} style={{padding: '1em 0', borderBottom: '1px solid var(--surface-border)'}}>
                        <div style={{display: 'flex', alignItems: 'center', gap: '0.6em'}}>
                            <h5 style={{margin: 0}}>{pickLocalized(a.title, i18n.language)}</h5>
                            {!a.seen && <Tag severity="info" value={t('announcement.new')}/>}
                        </div>
                        <small style={{color: 'var(--text-color-secondary)'}}>{toDateTimeString(a.published_at)}</small>
                        <AnnouncementBody html={pickLocalized(a.body_html, i18n.language)}/>
                    </div>
                )))}
    </div>;
};

export default Announcements;
